var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { getTheDayZeroTime } from '../../../helper/util';
import VueDialog from "../../../interface/IVueDialog";
import BusinessGoodsPriceService from '../../../api/BusinessGoodsPriceService';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            es_time: '',
            ee_time: '',
        };
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
        var es_time = this.es_time;
        this.formData.es_time = this.es_time;
        this.formData.ee_time = this.ee_time;
        this.endPickerOptions = {
            disabledDate: function (time) {
                var s_time = es_time;
                var now_time = new Date();
                if (s_time) {
                    return !(time.getTime() >= getTheDayZeroTime(s_time) && time.getTime() >= getTheDayZeroTime(now_time));
                }
                else {
                    return false;
                }
            }
        };
    };
    Dialog.prototype.mounted = function () {
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.confirm = function () {
        var data = {
            ee_time: this.formData.ee_time
        };
        this.$emit("submit", data);
    };
    Dialog = __decorate([
        Component
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
